import { parseRate } from '@koverta/shared';
import type { Fmt } from './household';

/** "12,00 %" from percent × 10 000. */
export const fmtPercent = (rate: number, fmt: Fmt) => `${fmt.rate(rate)} %`;

/** A typed percentage ("6,25") → percent × 10 000; "0" is a valid rate. */
export function parsePercent(input: string, fmt: Fmt): number | null {
  if (/^\s*0+([.,]0*)?\s*%?\s*$/.test(input)) return 0;
  return parseRate(input.replace('%', ''), fmt.locale);
}
